import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RHTextField } from '../../../../../../../dum';
import { IOrderProduction } from '../../order-production-form';
import { useOrderProductionNamePrefix } from '../../order-production-name-prefix.context';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_products_consumed';
const GROUPS_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'groups';
const KILOS_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderProduction['order_production_products_consumed'][number] =
    'group_weight';

interface IGroupsInputProps {
    index: number;
}

export function GroupsInput({ index }: IGroupsInputProps) {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;
    const INPUT_NAME = `${PREFIXED_ARRAY}.${index}.${GROUPS_FIELD_NAME}`;

    const formContext = useFormContext();

    return (
        <RHTextField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.groups)}
            disableGutters
            onChange={(inputValue) => {
                const groupWeightValue = formContext.getValues(
                    `${PREFIXED_ARRAY}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
                ) as IOrderProduction['order_production_products_consumed'][number]['group_weight'];

                if (inputValue && groupWeightValue) {
                    formContext.setValue(
                        `${PREFIXED_ARRAY}.${index}.${KILOS_FIELD_NAME}`,
                        inputValue * groupWeightValue,
                    );
                }
            }}
        />
    );
}
